export default __webpack_public_path__ + "static/media/kitchen5-beforeB.c81c59c6.jpg";